 <!-- Footer Start -->
 <footer class="footer mt-auto py-3 bg-white text-center">
    <div class="container">
        <span> Copyright © <span id="year">2025 - 2026</span> <a
                href="https://fusionlex.com" class="text-primary"> FusionLex</a>.
            Created by <a href="https://www.linkedin.com/in/abdelhafid-dahhani/">
                <span class="fw-semibold text-decoration-underline">Hafid DAHHANI, CEO.</span>
            </a> All
            rights
            reserved
        </span>
    </div>
</footer>
<!-- Footer End -->
